import { ProductMake, ProductType, SparePart } from "@/types";
import { getData, postData, putData, deleteData } from "./axios-service"


function modelMapper(inputSparepart: any): SparePart {
    const name = inputSparepart.name || "";
    const frenchName = inputSparepart.frenchName || "";
    return {
        id: inputSparepart.id,
        name: name,
        frenchName: frenchName,
        price: inputSparepart.price,
        unitInStock: inputSparepart.unitInStock,
        minUnitInStock: inputSparepart.minUnitInStock,
        reference: inputSparepart.reference,
        notificationEnabled: inputSparepart.notificationEnabled,
        productTypes: inputSparepart.productTypes,
        sparepartStatus: inputSparepart.sparepartStatus,
        sparepartMake: inputSparepart.sparepartMake,
        command: inputSparepart.command,
        stockValue: inputSparepart.stockValue,
        displayName: `${name} (${frenchName})`.trim(),
        productModels: inputSparepart.productModels || [],
        productModelIds: inputSparepart.productModelIds || [],
    };
}

export function modelMapperArray(inputArray: any[]): SparePart[] {
    return inputArray.map(modelMapper);
}

export async function getAllSpareparts(): Promise<SparePart[]> {
    const spareparts = await getData<SparePart[]>("spareparts");
    return modelMapperArray(spareparts ?? []);
}

export async function fetchFilteredSpareParts(sparePartMakes: ProductMake[], productTypes: ProductType[]): Promise<SparePart[]> {
    const params = new URLSearchParams();

    if (sparePartMakes.length > 0) {
        params.set("sparepart_makes", sparePartMakes.join(","));
    }

    if (productTypes.length > 0) {
        params.set("product_types", productTypes.join(","));
    }

    const query = params.toString();
    const url = query ? `spareparts?${query}` : "spareparts";

    const response = await getData<SparePart[]>(url);
    return modelMapperArray(response ?? []);
}

export function getSparepartById(id: string): Promise<SparePart> {
    return getData("spareparts/" + id).then(
        onSucceed => {
            return modelMapper(onSucceed);
        }
    );
}

export function postSparepart(sparepart: SparePart): Promise<SparePart> {
    return postData("spareparts", sparepart).then(
        onSucceed => {
            return modelMapper(onSucceed);
        }
    );
}

export function putSparepart(id: string, sparepart: SparePart): Promise<any> {
    return putData("spareparts/" + id, sparepart)
}

export function deleteSparepart(ids: string[]): Promise<any> {
    const idsStr = ids.join(',');
    return deleteData("spareparts/" + idsStr)
}

export async function searchForSpareparts(searchQuery: string): Promise<SparePart[]> {
    const spareparts = await getData<SparePart[]>("spareparts?" + searchQuery);
    return modelMapperArray(spareparts ?? []);
}